import * as React from 'react';
import { withProvider } from '../../redux';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ApplicationContext } from '../ApplicationContext';
import { DealRentDepositHint } from './DealRentDepositHint';

interface IDealRentDepositHintContainerProps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export const DealRentDepositHintContainer = withProvider(
  ({ httpApi, logger, config }: IDealRentDepositHintContainerProps) => {
    const context = { httpApi, logger, config };

    return (
      <ApplicationContext.Provider value={context}>
        <DealRentDepositHint />
      </ApplicationContext.Provider>
    );
  },
);
